import { Pen } from "lucide-react";
import React, { useState } from "react";
import ToggleSwitch from "../../../ui/ToggleSwitch";
import CustomModal from "../../../ui/CustomModal";
import UpdateSpecialChangeForm from "../form/UpdateSpecialChangeForm";
import { Instruction } from "../../../../types/modules/product.type";
import i18next from "i18next";
import { useParams } from "react-router-dom";
import { useUpdateResource } from "../../../../hooks/useUpdateResource";
import { PermissionGate } from "../../../admin/PermissionGate";
import { PermissionsKey } from "../../../../data/permissions";


type Props={
  specialChange:Instruction
}

function SpecialChangeBox({specialChange}:Props) {
      const [isOpen, setIsOpen] = useState(false);
      const enName = specialChange.languages.find(s=>s.languageCode==="en")?.name ||"";
      const arName = specialChange.languages.find(s=>s.languageCode==="ar")?.name ||"";

      const { productId , storeId} = useParams<{ productId: string ,storeId:string}>();
      const numericProductId = productId ? parseInt(productId) : 0;
      const numericStoreId = storeId ? parseInt(storeId) : undefined;

      const [isActive, setIsActive]= useState(specialChange.isActive);
      const {updateResource} = useUpdateResource();
    
      async function handleChangeActive(){
        setIsActive(p=>!p);
        const endPoint = numericStoreId ? `product-instruction/active/${specialChange.id}?storeId=${numericStoreId}` :`product-instruction/active/${specialChange.id}`
        await  updateResource(endPoint, {}, numericStoreId ?  "admin" :"store",{
            method: "PUT",
            invalidateQueries:["product-detail"],
      });
      }

  return (
    <div className="flex items-center justify-between py-4 w-[330px]">
      {/* Left side:  Title */}
        {/* Title */}
        <div>
        <h3 className="font-medium text-sm text-Black">{specialChange.languages.find(s=>s.languageCode===i18next.language)?.name}</h3>
      </div>

      {/* Right side: Edit + Toggle */}
      <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
        <div className="flex items-center gap-2">
          {/* Edit Button */}
        <button 
        onClick={() => setIsOpen(true)}
        className="text-primaryButton hover:underline flex items-center gap-1">
          <Pen size={16} />
        </button>

        {/* Toggle Switch */}
        <ToggleSwitch checked={isActive} onChange={handleChangeActive} size="sm" />
      </div>
      </PermissionGate>
      {/* modal */}
        <CustomModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            title="Update Special Change Item"
            >
            <UpdateSpecialChangeForm
                initialValues={{
                productId: numericProductId,
                languages: [
                    { languageCode: "en", name: enName },
                    { languageCode: "ar", name: arName },
                ],
                }}
                id={specialChange.id}
                onSubmitSuccess={() => setIsOpen(false)}
                storeId={numericStoreId}
            />
        </CustomModal>

    </div>
  );
}

export default SpecialChangeBox;
